<label class="hx-radio__label" [class.hx-radio__label--disabled]="_isDisabled()">
  <span class="hx-radio__container">
    <input
      #nativeInput
      class="hx-radio__native"
      type="radio"
      tabindex="-1"
      [attr.aria-label]="name()"
      [attr.aria-posinset]="_ariaPosinset()"
      [attr.aria-setsize]="_ariaSetsize()"
      [attr.name]="name()"
      [attr.value]="value()"
      [checked]="checked()"
      [disabled]="_isDisabled()"
      [stopPropagation]="['change']"
      (keydown)="_onNativeKeydown($event)"
      (change)="_onInputChange($event)"
      (click)="_onInputClick($event)" />
    <span class="hx-radio__circle" role="presentation">
      <span class="hx-radio__inner"></span>
      <span class="hx-radio__overlay"></span>
    </span>
  </span>
  <span class="hx-radio__content" [class.hx-radio__content--disabled]="_isDisabled()">
    <ng-content />
  </span>
</label>
